import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedDepot: '',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSelectedDepot(state, action) {
      state.selectedDepot = action.payload;
    },
  },
});

export const { setSelectedDepot } = appSlice.actions;

export default appSlice.reducer;
